module.exports = __webpack_public_path__ + "static/media/checkbox1_dark.2ab4a161.svg";